<app-table-card-layout
    #cardLayout
    title="Notes"
    [isLoading]="isDCPolicyLoaded"
    [failed]="dcPolicyFailed"
    [hasData]="notes.length > 0"
    [noDataMessage]="globalMessages.noDataAvailabelMsg"
    [errorMessage]="globalMessages.serviceMsgError"
    (retry)="retryDCPolicy()"
>
    @if (!isDCPolicyLoaded && !dcPolicyFailed) {
        <div headerActions>
            <lib-button
                [buttonText]="'Add note'"
                [buttonSize]="'small'"
                [libIcon]="'add'"
                (callback)="addNewNotes()"
            ></lib-button>
        </div>
    } @if (notes.length > 0) {
        <div class="d-flex flex-column psic-gap-6">
            <div class="d-flex flex-column">
                <div class="d-flex flex-row align-items-center justify-content-between">
                    <div class="d-flex flex-row align-items-center psic-gap-3">
                        <app-pills
                            [pills]="pills"
                            [multiple]="true"
                            [selectable]="selectable"
                            (filteredDataList)="filteredData($event)"
                            [filteredDataFilter]="filteredDataFilter"
                        ></app-pills>
                        <lib-button
                            [buttonType]="'borderless'"
                            [buttonSize]="'medium'"
                            [buttonText]="'Reset'"
                            (callback)="refreshPage()"
                        ></lib-button>
                    </div>
                    <!-- <lib-button
                        [buttonText]="'Add note'"
                        [buttonSize]="'large'"
                        [libIcon]="'add'"
                        (callback)="addNewNotes()"
                    ></lib-button> -->
                </div>
            </div>

            @if (totalRecords === 0) {
                <div class="text-center disclaimer psic-py-4">No notes found for the selected filter.</div>
            } @else if (!cardLayout.isCompact()) {
                <!-- Standard table view -->
                <div class="table-container" [class.table-container--collapsed]="!showAll() && filteredNotes.length > 5">
                    <table>
                        <thead>
                            <tr class="disclaimer-bold">
                                <th style="width: 150px">Call number</th>
                                <th style="width: 150px">Created by</th>
                                <th class="date-column" style="width: 200px">Date</th>
                                <th style="width: 200px">Category</th>
                                <th style="width: 300px">Note</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (note of filteredNotes; track note; let i = $index) {
                            <tr>
                                <td class="disclaimer">{{ note.callNumber }}</td>
                                <td class="disclaimer">{{ note.createdBy }}</td>
                                <td class="disclaimer date-column">{{ note.date | date : 'MM-dd-yyyy | hh:mm a' }}</td>
                                <td class="disclaimer">{{ note.category }}</td>
                                <td class="disclaimer">{{ note.note }}</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            } @else if (totalRecords > 0) {
                <!-- Compact 2-column key-value view -->
                <div class="compact-list d-flex flex-column psic-gap-6" [class.compact-list--collapsed]="!showAll() && filteredNotes.length > 5">
                    @for (note of filteredNotes; track note; let i = $index) {
                    <div class="compact-card">
                        <table class="compact-table">
                            <tbody class="d-flex flex-column psic-gap-3 psic-py-3">
                                <tr>
                                    <td class="compact-label disclaimer-bold">Call number</td>
                                    <td class="compact-value disclaimer">{{ note.callNumber }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Created by</td>
                                    <td class="compact-value disclaimer">{{ note.createdBy }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Date</td>
                                    <td class="compact-value disclaimer">{{ note.date | date : 'MM-dd-yyyy | hh:mm a' }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Category</td>
                                    <td class="compact-value disclaimer">{{ note.category }}</td>
                                </tr>
                                <tr>
                                    <td class="compact-label disclaimer-bold">Note</td>
                                    <td class="compact-value disclaimer">{{ note.note }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    } @empty {
                        <div class="text-center disclaimer psic-py-4">No notes available.</div>
                    }
                </div>
            } @if (!showAll() && filteredNotes.length > 5) {
                <div class="d-flex flex-row justify-content-center align-items-center w-100">
                    <lib-button
                        [buttonType]="'borderless'"
                        [buttonSize]="'medium'"
                        [buttonText]="'Show more'"
                        [libIcon]="'chevron-down'"
                        (callback)="loadMoreNotes()"
                    ></lib-button>
                </div>
            } @else if (showAll() && filteredNotes.length > 5) {
                <div class="d-flex flex-row justify-content-center align-items-center w-100">
                    <lib-button
                        [buttonType]="'borderless'"
                        [buttonSize]="'medium'"
                        [buttonText]="'Show less'"
                        [libIcon]="'chevron-up'"
                        (callback)="showLessNotes()"
                    ></lib-button>
                </div>
            }
        </div>
    }
</app-table-card-layout>

<ng-template #sidePanelContent>
    <div class="d-flex flex-column">
        <h6 class="psic-mb-7">{{ sidePanelField.caption }}</h6>
    </div>

    <div class="d-flex flex-column psic-gap-4">
        <div class="d-flex justify-content-between psic-pt-4 psic-pb-2">
            <p class="alt-bold">Policy number</p>
            <p class="caption-italic align-self-end">{{ policyId }}</p>
        </div>
        <app-dynamic-form [fields]="sidePanelField?.options?.optionsList" [parentFormArray]="sidePanelForm">
        </app-dynamic-form>
    </div>
</ng-template>

<ng-template #sidePanelFooter>
    <lib-button (callback)="cancelNotes()" buttonText="Cancel" buttonType="borderless"></lib-button>
    <lib-button
        [disabled]="isViewMode || !sidePanelForm.valid"
        (callback)="onSaveNotes()"
        buttonText="Save note"
    ></lib-button>
</ng-template>
